import { vars } from '../helpers';
import * as convertors from '../convertors';

export const getFeedCssVars = vars(({ styleParams: { booleans } }) => ({
  'create-post-display': convertors.display(booleans.showCreatePost),
  'share-button-display': convertors.display(booleans.showShareButton),
  'reactions-display': convertors.display(booleans.showReactions),
  'reactions-visibility': convertors.visibility(booleans.showReactions),
}));
